import { Link } from 'react-router-dom';

export function Terms() {
  return (
    <div
      className="min-h-screen h-screen overflow-y-auto"
      style={{ backgroundColor: 'var(--color-bg-primary)' }}
    >
      <div className="max-w-3xl mx-auto px-6 py-12">
        {/* Header */}
        <div className="mb-8 flex justify-between items-center">
          <Link
            to="/"
            className="text-sm hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            &larr; Home
          </Link>
          <Link
            to="/terms/ko"
            className="text-sm hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            Korean
          </Link>
        </div>

        <h1
          className="text-3xl font-bold mb-2"
          style={{ color: 'var(--color-text-primary)' }}
        >
          Terms of Service
        </h1>
        <p
          className="text-sm mb-8"
          style={{ color: 'var(--color-text-secondary)' }}
        >
          Effective Date: December 7, 2025
        </p>

        <div
          className="space-y-8 text-sm leading-relaxed"
          style={{ color: 'var(--color-text-secondary)' }}
        >
          {/* Article 1 - Purpose */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 1 (Purpose)
            </h2>
            <p>
              These Terms of Service (hereinafter &quot;Terms&quot;) govern the
              rights, obligations, and responsibilities between BaseLabs Corp.
              (hereinafter &quot;Company&quot;) and users in relation to the use
              of services provided by the Company.
            </p>
          </section>

          {/* Article 2 - Definitions */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 2 (Definitions)
            </h2>
            <p className="mb-3">
              The definitions of key terms used in these Terms are as follows:
            </p>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                &quot;Service&quot; refers to all services provided by the
                Company that &quot;Users&quot; can use, regardless of the device
                (including PCs, TVs, mobile devices, and other wired/wireless
                devices).
              </li>
              <li>
                &quot;User&quot; refers to &quot;Individual Members,&quot;
                &quot;Corporate Members,&quot; and &quot;Non-members&quot; who
                receive services provided by the Company under these Terms.
              </li>
              <li>
                &quot;Individual Member&quot; refers to a person who has
                registered as a member by providing personal information to the
                Company and can continuously receive information and use
                services provided by the Company.
              </li>
              <li>
                &quot;Corporate Member&quot; refers to a person who has
                registered as a member by providing corporate and personal
                information to the Company and can continuously receive
                information and use services provided by the Company.
              </li>
              <li>
                &quot;Non-member&quot; refers to a person who uses services
                provided by the Company without registering as a member.
              </li>
              <li>
                &quot;ID&quot; refers to a combination of letters or letters and
                numbers that the member selects and the Company approves for
                member identification and service use.
              </li>
              <li>
                &quot;Password&quot; refers to a combination of letters
                (including special characters) and numbers that the member sets
                to verify that they are the member assigned the ID and to
                protect confidentiality.
              </li>
              <li>
                &quot;Paid Service&quot; refers to all services provided by the
                Company for a fee.
              </li>
              <li>
                &quot;Payment&quot; refers to the act of the member selecting a
                payment method and entering financial information to use paid
                services provided by the Company.
              </li>
            </ol>
          </section>

          {/* Article 3 - Supplementary Rules */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 3 (Supplementary Rules)
            </h2>
            <p>
              Matters not specified in these Terms shall be governed by laws,
              individual terms, operating policies, and rules (hereinafter
              &quot;detailed guidelines&quot;) established by the Company. In
              case of conflict between these Terms and detailed guidelines, the
              detailed guidelines shall prevail.
            </p>
          </section>

          {/* Article 4 - Effect and Amendment of Terms */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 4 (Effect and Amendment of Terms)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                These Terms are posted on all internet services provided by
                BaseLabs Corp. The Company may amend these Terms within the scope
                not violating relevant laws and regulations. When the Terms are
                amended, the Company shall determine the content and effective
                date of the amended Terms and publicly announce them from at
                least 7 days (30 days for changes that are unfavorable or
                significant to users) before the effective date until a
                considerable period after the effective date, and individually
                notify existing users of the amended Terms, effective date, and
                reasons for the change by electronic means. The amended Terms
                shall take effect from the announced effective date.
              </li>
              <li>
                When the Company announces or notifies the amended Terms
                pursuant to Paragraph 1, the Company shall also notify that
                &quot;if you do not agree with the changes, you may terminate
                the contract within 7 days (30 days for changes that are
                unfavorable or significant) from the announcement or
                notification date, and if you do not express your intention to
                terminate, you will be deemed to have agreed to the
                changes.&quot;
              </li>
              <li>
                If the user does not express objection to the amended Terms
                within 7 days (30 days for changes that are unfavorable or
                significant) from the announcement or notification date pursuant
                to Paragraph 2, the user shall be deemed to have agreed to the
                amendment of these Terms.
              </li>
            </ol>
          </section>

          {/* Article 5 - Notification to Users */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 5 (Notification to Users)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                Unless otherwise specified in these Terms, the Company may
                notify users by electronic means such as email, SMS, electronic
                notes, and push notifications.
              </li>
              <li>
                For notifications to all users, the Company may substitute the
                notification in Paragraph 1 by posting on the bulletin board of
                the website operated by the Company for at least 7 days.
                However, individual notifications pursuant to Paragraph 1 shall
                be made for matters that significantly affect the
                user&apos;s transactions.
              </li>
              <li>
                In cases where individual notification is difficult due to the
                user&apos;s failure to provide contact information, failure to
                update after changes, or incorrect information, the Company may
                substitute individual notification by making the announcement in
                the preceding paragraph.
              </li>
            </ol>
          </section>

          {/* Article 6 - Conclusion of Use Agreement */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 6 (Conclusion of Use Agreement)
            </h2>
            <p className="mb-3">
              Use agreements are concluded in the following cases:
            </p>
            <ol className="list-decimal list-inside space-y-2">
              <li>
                When a user wishes to register as a member, agrees to the
                contents of the Terms, applies for membership, and the Company
                approves such application
              </li>
              <li>
                When a user wishes to use services available without membership
                registration and makes payment for Company services
              </li>
              <li>
                When a user wishes to use free services available without
                membership registration and proceeds with steps 1 and 2 above
                while using additional services such as saving related
                information
              </li>
            </ol>
          </section>

          {/* Article 7 - Approval of Membership Registration */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 7 (Approval of Membership Registration)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                In principle, the Company approves service use when there is a
                request for a use agreement.
              </li>
              <li>
                Notwithstanding the preceding paragraph, the Company may
                withhold or reject membership registration in the following
                cases:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>
                    When the applicant has previously lost membership
                    qualification under these Terms (except when re-registration
                    is approved by the Company)
                  </li>
                  <li>When using a false name or another person&apos;s name</li>
                  <li>
                    When required information is omitted or falsely provided
                  </li>
                  <li>
                    When minors under 14, minors under 19, persons under limited
                    guardianship, or persons under adult guardianship have not
                    obtained consent from a legal representative
                  </li>
                  <li>
                    When approval is impossible due to user&apos;s fault or when
                    operating principles established by the Company are violated
                  </li>
                  <li>
                    When registered as a credit defaulter for PC communications
                    or internet services under the Credit Information Use and
                    Protection Act
                  </li>
                  <li>
                    When registered as a problematic user for PC communications
                    or internet services by the Information and Communication
                    Ethics Committee
                  </li>
                  <li>
                    When attempting to use member information already in use or
                    an ID that undermines public order and morals
                  </li>
                </ul>
              </li>
              <li>
                For applications under Paragraph 1, the Company may request
                identity verification and authentication through specialized
                agencies if necessary for service provision.
              </li>
              <li>
                The Company may withhold approval when there is insufficient
                service-related equipment or technical or operational issues.
              </li>
              <li>
                When service use is not approved or withheld pursuant to
                Paragraphs 2 and 4, the Company shall in principle notify the
                service applicant, except when notification is impossible
                through no fault of the Company.
              </li>
              <li>
                The timing of use agreement establishment is when the Company
                indicates completion of registration in the application process
                for Article 6 Paragraph 1, and when payment completion is
                indicated for Article 6 Paragraph 2.
              </li>
              <li>
                The Company may differentiate usage by subdividing usage time,
                frequency, and service menus by grade according to Company
                policy.
              </li>
              <li>
                The Company may impose usage restrictions or grade-based
                restrictions for members to comply with ratings and age
                requirements under the Motion Pictures and Video Products
                Promotion Act and Youth Protection Act.
              </li>
            </ol>
          </section>

          {/* Article 8 - Changes to Member Information */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 8 (Changes to Member Information)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                Members may view and modify their personal information at any
                time through the personal information management screen.
                However, real name and ID necessary for service management
                cannot be modified.
              </li>
              <li>
                If information provided at the time of membership registration
                changes, members must modify it online or notify the Company of
                the changes by email or other means.
              </li>
              <li>
                Members are responsible for any disadvantages arising from
                failure to notify the Company of changes pursuant to Paragraph
                2.
              </li>
            </ol>
          </section>

          {/* Article 9 - Management and Protection of Member Information */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 9 (Management and Protection of Member Information)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                Members are responsible for managing their ID and password and
                must not allow third parties to use them.
              </li>
              <li>
                The Company may restrict the use of a member&apos;s ID if there
                is concern about personal information leakage, if it is
                antisocial or contrary to public order and morals, or if there
                is concern about confusion with the Company or service operator.
              </li>
              <li>
                If a member becomes aware that their ID and password have been
                stolen or are being used by a third party, they must immediately
                notify the Company and follow guidance.
              </li>
              <li>
                In the case of Paragraph 3, the Company is not responsible for
                any disadvantages arising from the member&apos;s failure to
                notify the Company of such fact or failure to follow the
                Company&apos;s guidance after notification.
              </li>
            </ol>
          </section>

          {/* Article 10 - Obligations of the Company */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 10 (Obligations of the Company)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                The Company shall promptly repair or restore equipment that
                malfunctions or is destroyed for continuous and stable service
                provision, and may temporarily suspend all or part of the
                service without prior notice in unavoidable cases when the
                following reasons occur. In such cases, the Company shall notify
                users of the reasons and suspension period without delay:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>
                    When necessary for emergency system inspection,
                    augmentation, replacement, facility repair, or construction
                  </li>
                  <li>
                    When system replacement is deemed necessary to provide new
                    services
                  </li>
                  <li>
                    When normal service provision is impossible due to system or
                    other service equipment failure, wired/wireless network
                    failure, etc.
                  </li>
                  <li>
                    In case of national emergency, power failure, or force
                    majeure
                  </li>
                </ul>
              </li>
              <li>
                The Company shall strive to provide convenience to users in
                procedures and contents related to contracts with users,
                including conclusion of use agreements, changes to contract
                terms, and termination.
              </li>
              <li>
                The Company shall post the representative&apos;s name, trade
                name, address, telephone number, fax number, mail-order business
                registration number, Terms of Service, Privacy Policy, etc., on
                the initial screen of online services so that users can easily
                access them.
              </li>
            </ol>
          </section>

          {/* Article 11 - Protection of Personal Information */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 11 (Protection of Personal Information)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                The Company values users&apos; personal information and strives
                to comply with relevant laws and regulations including the Act
                on Promotion of Information and Communications Network
                Utilization and Information Protection and the Personal
                Information Protection Act. The Company informs users through
                its Privacy Policy about how the personal information they
                provide is used and what measures are taken for personal
                information protection.
              </li>
              <li>
                When there is no service usage history for one consecutive year
                from the last use date, the Company may separately store and
                manage user information from other users&apos; personal
                information in accordance with the Personal Information
                Protection Act and its Enforcement Decree. The separately stored
                personal information shall be retained until the user requests
                account deletion or personal information deletion.
              </li>
              <li>
                The Company applies relevant laws and the Company&apos;s Privacy
                Policy to the protection and use of users&apos; personal
                information. However, the Company&apos;s Privacy Policy does not
                apply to external web pages linked from websites operated by the
                Company.
              </li>
            </ol>
          </section>

          {/* Article 12 - Obligations of Users */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 12 (Obligations of Users)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                When applying for use through user registration, users must fill
                out the application form based on facts. If users register false
                or another person&apos;s information, they cannot claim any
                rights against the Company, and the Company shall not be liable
                for any damages arising therefrom.
              </li>
              <li>
                Users must comply with matters stipulated in these Terms and
                other regulations established by the Company and matters
                announced by the Company. Users must not engage in acts that
                interfere with the Company&apos;s business or damage the
                Company&apos;s reputation.
              </li>
              <li>
                If member information such as address, contact information, or
                email address changes, users must immediately modify it online.
                Users are responsible for any consequences arising from failure
                to modify or delay in modifying changed information.
              </li>
              <li>
                Users must directly manage the ID and password assigned to them.
                The Company is not responsible for problems arising from
                user&apos;s negligent management.
              </li>
              <li>
                When selecting IDs, nicknames, or other names used in the
                service, users must not engage in the following acts:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>
                    Acts of impersonating the official operator of services
                    provided by the Company or using similar names to confuse
                    other users
                  </li>
                  <li>Using names containing suggestive or obscene content</li>
                  <li>
                    Using names that may infringe on third parties&apos;
                    trademark rights, copyrights, or other rights
                  </li>
                  <li>
                    Using names that may defame third parties or interfere with
                    their business
                  </li>
                  <li>
                    Using names containing antisocial content or content that
                    violates relevant laws
                  </li>
                </ul>
              </li>
              <li>
                Users may not sell, gift, provide as collateral, or otherwise
                dispose of service usage rights or other contractual status
                without the Company&apos;s explicit consent.
              </li>
              <li>
                Precautions and other details regarding service use in relation
                to this Article shall be determined by the operating policy. If
                users violate the Terms of Service and operating policy,
                disadvantages such as service use restrictions and civil and
                criminal liability may occur.
              </li>
            </ol>
          </section>

          {/* Article 13 - Provision of Services */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 13 (Provision of Services)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                In principle, the Company&apos;s services are provided 24 hours
                a day, 365 days a year. However, temporary suspension of all or
                part of the services may occur due to special reasons such as
                system maintenance inspections or replacement of communication
                equipment.
              </li>
              <li>
                Specific information about individual services provided by the
                Company can be found on the individual service screens.
              </li>
              <li>
                The services provided by the Company include the following:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>
                    Real-time cycling telemetry visualization service provided
                    through website and mobile
                  </li>
                  <li>
                    Real-time data collection and display through integration
                    with Garmin devices
                  </li>
                  <li>
                    Group riding event creation, participation, and spectating
                    services
                  </li>
                  <li>
                    Replay services based on FIT files and Strava activities
                  </li>
                </ul>
              </li>
            </ol>
          </section>

          {/* Article 14 - Restrictions on Services */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 14 (Restrictions on Services)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                The Company may restrict or suspend all or part of the services
                in cases of war, incident, natural disaster, or similar national
                emergency, or when there are unavoidable reasons such as
                suspension of telecommunications services by a key
                telecommunications carrier under the Telecommunications Business
                Act.
              </li>
              <li>
                Notwithstanding the preceding paragraph, free services may be
                restricted, suspended, or converted to paid services due to the
                Company&apos;s operating policy.
              </li>
              <li>
                When restricting or suspending service use, the Company shall
                promptly notify users of the reasons, restriction period, and
                scheduled date.
              </li>
              <li>
                When converting a service currently provided for free to a paid
                service after receiving payment information in advance, the
                Company shall notify the reasons and scheduled date for paid
                conversion and obtain user consent for the paid conversion.
              </li>
            </ol>
          </section>

          {/* Article 15 - Termination and Withdrawal Procedures */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 15 (Termination and Withdrawal Procedures)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                When users wish to terminate the use agreement, they may request
                termination through the user withdrawal application on the
                website at any time. However, immediate withdrawal may be
                restricted for a certain period after new registration to
                prevent service abuse.
              </li>
              <li>
                The Company may notify users and terminate the contract if users
                violate user obligations under these Terms, engage in abnormal
                or improper use, use prohibited programs, or create broadcasts
                or posts that defame or insult others, and such acts are
                prohibited or requested to be deleted but accumulate 2 or more
                times including the initial prohibition or deletion request.
              </li>
              <li>
                Upon receiving a user&apos;s expression of withdrawal, release,
                or termination, the Company shall reply to the user. The reply
                shall be made by one of the methods by which the user contacted
                the Company, and no reply may be made if the user&apos;s contact
                information notified to the Company does not exist.
              </li>
            </ol>
          </section>

          {/* Article 16 - Damages */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 16 (Damages)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                The Company or user may claim damages when damage occurs due to
                the other party&apos;s fault. However, the Company shall not be
                liable for damages caused by free service failures, suspension
                of provision, loss or deletion of stored data, or alterations.
              </li>
              <li>
                The Company shall not be liable for any damages unless it
                violates the Company&apos;s operating policy, Privacy Policy, or
                other service-specific Terms of Service in connection with the
                use of services provided by the Company.
              </li>
            </ol>
          </section>

          {/* Article 17 - Disclaimer */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 17 (Disclaimer)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                The Company shall not be liable for service provision when it is
                unable to provide services due to natural disasters or
                equivalent force majeure.
              </li>
              <li>
                The Company shall not be liable for service use failures caused
                by users&apos; fault.
              </li>
              <li>
                The Company shall not be liable for users not obtaining expected
                profits from using the service or for damages caused by data
                obtained through the service.
              </li>
              <li>
                The Company shall not be responsible for the reliability or
                accuracy of content posted by users on web pages and shall not
                intervene in disputes arising between users or between users and
                third parties through the service.
              </li>
            </ol>
          </section>

          {/* Article 18 - Information Provision and Advertising */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 18 (Information Provision and Advertising)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                The Company may provide (or transmit) various information and
                advertisements deemed necessary during service use to users by
                banner posting, email, mobile messages, telephone, mail, etc.
                However, users may refuse to receive such information through
                the method provided by the Company.
              </li>
              <li>
                Even if users refuse to receive, the Company may provide
                information by email or other means for matters that users must
                know, such as changes to Terms of Service, Privacy Policy, or
                other important matters affecting users&apos; interests as
                provided in the Act on Promotion of Information and
                Communications Network Utilization and Information Protection.
              </li>
              <li>
                The Company shall not be responsible when it fails to deliver
                transaction-related information, answers to usage inquiries, or
                other information due to users taking opt-out measures pursuant
                to Paragraph 1.
              </li>
              <li>
                The Company confirms consent to receive commercial advertising
                information every 2 years in accordance with the Enforcement
                Decree of the Information and Communications Network Act.
              </li>
              <li>
                The Company shall not be liable for any loss or damage arising
                from users&apos; participation in advertisers&apos; promotional
                activities or transactions.
              </li>
            </ol>
          </section>

          {/* Article 19 - Payment for Paid Services */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 19 (Payment for Paid Services)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                In principle, users must pay usage fees when using paid services
                provided by the Company. Payment methods for paid services
                provided by the Company are as follows:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>
                    Various card payments including prepaid cards, debit cards,
                    and credit cards
                  </li>
                  <li>
                    Various account transfers including phone banking, internet
                    banking, and online bank transfers
                  </li>
                </ul>
              </li>
              <li>
                The Company may verify whether users have legitimate authority
                over payment methods and may suspend transaction processing or
                cancel the transaction if verification is not possible.
              </li>
              <li>
                Monthly cumulative payment amounts and charging limits per user
                may be limited according to Company policy and standards of
                payment companies (mobile carriers, card companies, etc.) and
                payment processing companies in Paragraph 1. Additional use of
                paid services may not be possible if such limits are exceeded.
              </li>
              <li>
                Users are responsible for information entered for payment or
                settlement.
              </li>
            </ol>
          </section>

          {/* Article 20 - Refunds */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 20 (Refunds)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                When canceling or refunding payment due to user&apos;s fault,
                the following procedures apply:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>
                    Services that are completed with one-time use or purchase
                    are non-refundable.
                  </li>
                  <li>
                    For continuously usable services, the remaining amount after
                    deducting the amount corresponding to the days of use shall
                    be refunded.
                  </li>
                </ul>
              </li>
              <li>
                Notwithstanding the preceding paragraph, the full amount paid
                shall be refunded in the following cases:
                <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
                  <li>When there is no service usage history after payment</li>
                  <li>
                    When the service could not be used due to the Company&apos;s
                    fault such as service failure
                  </li>
                  <li>When the purchased service was not provided</li>
                  <li>
                    When the purchased service is different from or
                    significantly different from the display or advertisement
                  </li>
                  <li>
                    When service use was significantly impossible due to defects
                    in the service itself
                  </li>
                </ul>
              </li>
              <li>
                In principle, the Company refunds by the same method as the
                payment method. However, if refund by the same payment method is
                not possible, the Company shall refund by a separate method
                specified in individual services.
              </li>
              <li>
                The Company shall proceed with refund procedures within 3
                business days from the date the refund obligation arises.
                However, the Company shall not bear delay interest when refund
                is delayed due to user&apos;s fault when user cooperation is
                required for refund.
              </li>
              <li>
                The party at fault shall bear the costs required for refund.
              </li>
            </ol>
          </section>

          {/* Article 21 - Ownership of Rights */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 21 (Ownership of Rights)
            </h2>
            <ol className="list-decimal list-inside space-y-3">
              <li>
                Copyrights and other intellectual property rights for services
                provided by the Company belong to the Company.
              </li>
              <li>
                The Company only grants users the right to use the services
                provided by the Company according to terms set by the Company in
                connection with the services, and users may not sell, gift,
                provide as collateral, or otherwise dispose of such rights.
              </li>
            </ol>
          </section>

          {/* Article 22 - Jurisdiction and Governing Law */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Article 22 (Jurisdiction and Governing Law)
            </h2>
            <p>
              In case of disputes related to the services, the court having
              jurisdiction over the Company&apos;s location shall be the
              competent court, and the laws of the Republic of Korea shall
              apply as governing law.
            </p>
          </section>

          {/* Supplementary Provisions */}
          <section>
            <h2
              className="text-xl font-semibold mb-3"
              style={{ color: 'var(--color-text-primary)' }}
            >
              Supplementary Provisions
            </h2>
            <p>These Terms shall take effect from December 7, 2025.</p>
          </section>
        </div>

        {/* Footer */}
        <div
          className="mt-12 pt-8 border-t text-center text-sm"
          style={{
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-muted)',
          }}
        >
          <div className="flex justify-center gap-4 mb-2">
            <Link
              to="/terms"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              Terms of Service
            </Link>
            <span style={{ color: 'var(--color-border)' }}>|</span>
            <Link
              to="/privacy"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              Privacy Policy
            </Link>
            <span style={{ color: 'var(--color-border)' }}>|</span>
            <Link
              to="/contact"
              className="hover:underline"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              Contact
            </Link>
          </div>
          &copy; 2025{' '}
          <a
            href="https://baselabs.co.kr"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            BaseLabs Corp.
          </a>{' '}
          All rights reserved.
        </div>
      </div>
    </div>
  );
}
